module.exports = __webpack_public_path__ + "img/thumb-evs.d46a0846.png";